import { IMedication } from 'API';
import { api } from 'API/axios';
import { addImposterToUrl } from 'Utils';

const baseURL = '/Recommendations';

interface IRecommendationItem {
  reqNumber: number;
  shemeshCatalogNumber: number;
  nextEntitleDate: Date;
  medicatioN_NAME?: string;
  nextrefreshdate?: Date;
}

export interface IRecommendations {
  caseNumber: string;
  createDate: Date;
  isClosed: boolean;
  title: string;
  description: string;
  subjectId: number;
  entityJSON: {
    items: IRecommendationItem[];
    title?: string;
  };
}

export interface IMedicationRecommendation extends IRecommendationItem {
  medicatioN_NAME: string;
  nextrefreshdate: Date;
  medicationCode: number;
}

interface IDeleteRecommendationBody {
  reqNumber: string;
  nextEntitleDate: Date;
}

export const getRecommendations = async () => {
  const recommendations = await api.get<IRecommendations[]>(
    addImposterToUrl(baseURL, true)
  );
  if (recommendations.data) return recommendations.data;
};

export const deleteRecommendation = async (
  body: IDeleteRecommendationBody,
  reqPath: string
) => {
  const deleteRequest = await api.post(
    addImposterToUrl(`${baseURL}/${reqPath}`, true),
    body,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  if (deleteRequest.data) return deleteRequest.data;
};
